/**
 * Utility functions for performance optimization initialization and cleanup
 */

import {
  batchedUserFetcher,
  lazyLoadManager,
  subscriptionManager,
  commentCache,
  requestDeduplicator
} from './instances.js';

/**
 * Initialize performance optimization utilities with Redux dispatch
 * @param {Function} dispatch - Redux dispatch function
 */
export const initialize = (dispatch) => {
  batchedUserFetcher.dispatch = dispatch;
  // Expose to window for global access
  window.batchedUserFetcher = batchedUserFetcher;
  window.lazyLoadManager = lazyLoadManager;
};

/**
 * Cleanup all performance optimization utilities
 */
export const cleanup = () => {
  batchedUserFetcher.clear();
  lazyLoadManager.disconnect();
  subscriptionManager.cleanup();
  commentCache.clear();
  requestDeduplicator.clear();
};
